import { useSelector } from "react-redux";
import { useManagerPaymentQuery } from "queries/Sales/useManagerPaymentQuery";
import { toReferenceDate, PERIOD_COUNT } from "pages/Sales/_lib/toReferenceDate";
import type { PeriodType } from "types/ManagerPayment";

/**
 * 홈(/sales)의 PeriodInfo·VoucherInfo가 동일 파라미터로 호출해
 * React Query 키 dedup(홈 1콜)이 되도록 하는 공용 훅.
 */
export const useHomePaymentQuery = () => {
  const { searchDate, searchPeriodType } = useSelector((s: any) => s.sales);
  const { seqPartner, seqPartnerBranch } = useSelector((s: any) => s.partner);
  const periodType: PeriodType = searchPeriodType || "daily";

  const query = useManagerPaymentQuery({
    seqPartner,
    periodType,
    referenceDate: searchDate ? toReferenceDate(periodType, searchDate) : "",
    periodCount: PERIOD_COUNT[periodType],
    seqPartnerBranches: seqPartnerBranch ? [seqPartnerBranch] : undefined,
  });

  return { query, periodType };
};
